import React from 'react';
import './SocialLargeLinks.sass';

import { ReactComponent as FacebookLogo } from '../Icons/facebook-logo.svg';
import { ReactComponent as TwitterLogo } from '../Icons/twitter-logo.svg';
import { ReactComponent as LinkedinLogo } from '../Icons/linkedin-logo.svg';

interface Props {
	currentSpeaker?: {
		facebookLink: string;
		twitterLink: string;
		linkedinLink: string;
	};
}

function SocialLargeLinks(props: Props) {

	const facebookLink= buildSocialUrl(props.currentSpeaker?.facebookLink);
	const twitterLink = buildSocialUrl(props.currentSpeaker?.twitterLink);
	const linkedinLink = buildSocialUrl(props.currentSpeaker?.linkedinLink);

	return (
		<div className="uikit-socials-large-links">
			{linkedinLink && (
				<a
					href={linkedinLink}
					target="_blank"
					rel="noreferrer"
				>
					<LinkedinLogo />
				</a>
			)}
			{facebookLink && (
				<a
					href={facebookLink}
					target="_blank"
					rel="noreferrer"
				>
					<FacebookLogo />
				</a>
			)}
			{twitterLink && (
				<a
					href={twitterLink}
					target="_blank"
					rel="noreferrer"
				>
					<TwitterLogo />
				</a>
			)}
		</div>
	);
}

export default SocialLargeLinks;

function buildSocialUrl(url: string | undefined): string | undefined {
		const httpStr = 'https://'
		if (url) {
			return !url.includes('https://') ? `${httpStr}${url}` : url;
		}

		return undefined;
}
